import Api from "api"
import { ExtendedTicketInformation } from "../interface";

export async function findAllRole() {
    try {
        return Api("/roles", null, 'GET', null);
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export async function findAllStatus() {
    try {
        return Api("/status", null, 'GET', null);
    } catch (error) {
        console.error(error);
        throw error;
    }
}
export async function findAllTitle() {
    try {
        return Api("/title", null, 'GET', null);
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export async function findAllTitleDetail() {
    try {
        return Api("/title-detail", null, 'GET', null);
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export async function createTitleDetail(data: any) {
    try {
        return Api("/title-detail", data, 'POST', null);
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export async function createTicket(data: any) {
    try {
        return Api("/ticket-information", data, 'POST', null);
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export async function updateTicket(id: string, data: any) {
    try {
        const response = await Api(`/ticket-information/${id}`, data, 'PUT', null);
        return response;
    } catch (error) {
        console.error("Error updating ticket:", error);
        throw error;
    }
}

export async function findTicketByUserId(userId: number) {
    try {
        return Api(`/ticket-information/user/${userId}`, null, 'GET', null);
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export async function findTicketOfUserByTaskId(userId: number, taskId: number) {
    try {
        return Api(`/ticket-information/${userId}/${taskId}`, null, 'GET', null);
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export async function deleteTicket(userId: number) {
    try {
        return Api(`/ticket-information/${userId}`, null, 'DELETE', null);
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export async function findAllTicket(): Promise<ExtendedTicketInformation[]> {
    try {
        return Api(`/ticket-information`, null, 'GET', null);
    } catch (error) {
        console.error(error);
        throw error;
    }
}